const nonBlank = value => typeof value === 'string' && value.trim() !== '';

function normalizeTaskKeys(taskKeys) {
  if (!Array.isArray(taskKeys) || taskKeys.length === 0) return null;
  if (taskKeys.some(taskKey => !nonBlank(taskKey))) return null;
  const normalized = taskKeys.map(taskKey => taskKey.trim());
  if (new Set(normalized).size !== normalized.length) return null;
  return normalized;
}

export function sampleTaskProvenanceFromVoiceSample(selectedSample) {
  const taskKeys = normalizeTaskKeys(selectedSample?.vocalTasks?.includedVocalTasks);
  if (!taskKeys) return null;
  return {
    taskKeys,
    ...(selectedSample?.variantType ? { sampleClass: selectedSample.variantType } : {}),
  };
}

export function readSampleTaskProvenance(provenance) {
  if (!provenance || typeof provenance !== 'object' || Array.isArray(provenance)) {
    return { valid: false, taskKeys: null, reason: 'missing' };
  }
  const hasSingular = Object.prototype.hasOwnProperty.call(provenance, 'taskKey');
  const hasPlural = Object.prototype.hasOwnProperty.call(provenance, 'taskKeys');
  const hasCompleted = Object.prototype.hasOwnProperty.call(provenance, 'completedTaskKeys');

  if (hasPlural && (hasSingular || hasCompleted)) {
    return { valid: false, taskKeys: null, reason: 'contradictory-representations' };
  }
  if (hasPlural) {
    const taskKeys = normalizeTaskKeys(provenance.taskKeys);
    return taskKeys
      ? { valid: true, taskKeys, representation: 'plural' }
      : { valid: false, taskKeys: null, reason: 'invalid-plural' };
  }
  if (hasCompleted) {
    if (hasSingular && provenance.taskKey !== 'cape-vr-rating') {
      return { valid: false, taskKeys: null, reason: 'contradictory-representations' };
    }
    const taskKeys = normalizeTaskKeys(provenance.completedTaskKeys);
    return taskKeys
      ? { valid: true, taskKeys, representation: 'legacy-completed-task-keys' }
      : { valid: false, taskKeys: null, reason: 'invalid-legacy-completed-task-keys' };
  }
  if (hasSingular && nonBlank(provenance.taskKey)) {
    return {
      valid: true,
      taskKeys: [provenance.taskKey.trim()],
      representation: 'legacy-singular',
    };
  }
  return { valid: false, taskKeys: null, reason: 'missing' };
}

